import { Injectable, LOCALE_ID, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private localeId = inject(LOCALE_ID);

  private currentLocale: string = 'pt-br';

  constructor() {
    const localeId = this.localeId;

    this.currentLocale = localeId;
  }

  setLocale(locale: string) {
    this.currentLocale = locale;
  }

  getLocale(): string {
    return this.currentLocale;
  }
}
